export default __webpack_public_path__ + "static/media/icon-photo-circle-outline.2e8ffe25.svg";